import React from 'react';
import { AlertTriangle, X, Check } from 'lucide-react';

const ConfirmModal = ({ isOpen, onClose, onConfirm, onCancel, title, desc, confirmText = "確定", cancelText = "取消", isDanger = false }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-md overflow-hidden border border-slate-200 dark:border-slate-700 animate-scale-in">
                <div className="p-6 text-center">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 ${isDanger ? 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400' : 'bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400'}`}>
                        <AlertTriangle className="w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">{title}</h3>
                    <p className="text-slate-500 dark:text-slate-400 mb-6">{desc}</p>

                    <div className="flex gap-3 justify-center">
                        <button
                            onClick={onCancel || onClose}
                            className="px-4 py-2 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg font-medium transition-colors flex items-center gap-2"
                        >
                            <X className="w-4 h-4" />
                            <span>{cancelText}</span>
                        </button>
                        <button
                            onClick={onConfirm}
                            className={`px-6 py-2 text-white rounded-lg font-bold shadow-lg transition-all flex items-center gap-2 ${isDanger ? 'bg-red-600 hover:bg-red-700 shadow-red-200 dark:shadow-none' : 'bg-indigo-600 hover:bg-indigo-700 shadow-indigo-200 dark:shadow-none'}`}
                        >
                            <Check className="w-4 h-4" />
                            <span>{confirmText}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
